export const config = {
  apiUrl: process.env.VUE_APP_API_ENDPOINT,
  avatarBaseUrl: process.env.VUE_APP_AVATAR_BASE_URL,
  emptyAvatar: 'cat.jpg'
};
